import { TInquiriesDetailsData } from "@/interfaces";

const TollPaymentInquiryDetails = ({
  data,
}: {
  data: TInquiriesDetailsData;
}) => {
  return <div>InquiryDetails</div>;
};

export default TollPaymentInquiryDetails;
